import { render, staticRenderFns } from "./Remitos.vue?vue&type=template&id=42536b6f"
import script from "./Remitos.vue?vue&type=script&lang=ts"
export * from "./Remitos.vue?vue&type=script&lang=ts"
import style0 from "./Remitos.vue?vue&type=style&index=0&id=42536b6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports